<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="请选择" clearable>
            <el-option label="待处理" value="PENDING"></el-option>
            <el-option label="已处理" value="PROCESSED"></el-option>
            <el-option label="无效" value="INVALID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="举报类型">
          <el-select v-model="query.targetType" placeholder="请选择" clearable>
            <el-option label="帖子" value="POST"></el-option>
            <el-option label="用户" value="USER"></el-option>
            <el-option label="聊天" value="CHAT_MESSAGE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="reporterName" label="举报人" width="120"></el-table-column>
        <el-table-column prop="reportedName" label="被举报对象" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="targetType" label="类型" width="90">
          <template slot-scope="{ row }">
            <el-tag size="small">{{ formatTargetType(row.targetType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reportTypeLabel" label="举报原因" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag :type="formatStatusType(row.status)" size="small">
              {{ formatStatus(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="举报时间" width="160"></el-table-column>
        <el-table-column label="操作" width="320">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleDetail(row)">详情</el-button>
            <el-button v-if="row.targetType === 'POST'" type="text" @click="handleViewOriginalPost(row)">原帖</el-button>
            <el-button v-if="row.targetType === 'POST'" type="text" style="color: #E6A23C" @click="handleOfflinePost(row)">下架</el-button>
            <el-button v-if="row.targetType === 'POST'" type="text" style="color: #F56C6C" @click="handleDeletePost(row)">删除</el-button>
            <template v-if="isPending(row.status)">
              <el-button type="text" style="color: #67C23A" @click="handleProcess(row)">处理</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.pageNum = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <el-dialog title="举报详情" :visible.sync="detailVisible" width="500px">
      <el-descriptions border :column="1" v-if="currentReport">
        <el-descriptions-item label="举报人">{{ currentReport.reporterName }}</el-descriptions-item>
        <el-descriptions-item label="被举报对象">{{ currentReport.reportedName }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ formatTargetType(currentReport.targetType) }}</el-descriptions-item>
        <el-descriptions-item label="举报原因">{{ formatReportType(currentReport.reportType) }}</el-descriptions-item>
        <el-descriptions-item label="描述">{{ currentReport.description }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ formatStatus(currentReport.status) }}</el-descriptions-item>
        <el-descriptions-item label="处理结果" v-if="currentReport.processResult">{{ currentReport.processResult }}</el-descriptions-item>
        <el-descriptions-item label="举报时间">{{ currentReport.createTime }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="currentReport && currentReport.targetType === 'POST'" style="margin-top: 16px; text-align: right">
        <el-button size="small" @click="handleViewOriginalPost(currentReport)">查看帖子原文</el-button>
      </div>
    </el-dialog>

    <el-dialog title="帖子原文" :visible.sync="postVisible" width="960px">
      <div v-loading="postLoading">
        <template v-if="currentPost">
          <el-descriptions border :column="2">
            <el-descriptions-item label="ID">{{ currentPost.id }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="statusTagType(currentPost.status)" size="small">{{ statusText(currentPost.status) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="标题" :span="2">{{ currentPost.title || '-' }}</el-descriptions-item>
            <el-descriptions-item label="内容" :span="2">
              <div class="post-content-block">{{ postContentText }}</div>
            </el-descriptions-item>
            <el-descriptions-item label="发布者">{{ currentPost.userNickname || currentPost.username || currentPost.nickname || '-' }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{ currentPost.userMobile || currentPost.mobile || '-' }}</el-descriptions-item>
            <el-descriptions-item label="帖子类型">{{ postTypeText(currentPost.postType) }}</el-descriptions-item>
            <el-descriptions-item label="分类">
              {{ currentPost.parentCategoryName ? currentPost.parentCategoryName + ' > ' : '' }}{{ currentPost.categoryName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="城市">{{ currentPost.cityName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="区域">{{ currentPost.regionName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="地址" :span="2">{{ currentPost.address || '-' }}</el-descriptions-item>
            <el-descriptions-item label="发布时间">{{ currentPost.publishedTime || currentPost.createTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ currentPost.createTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="更新时间">{{ currentPost.updateTime || '-' }}</el-descriptions-item>
          </el-descriptions>

          <el-card style="margin-top: 16px" shadow="never">
            <div slot="header">媒体内容</div>
            <div v-if="originalImageList.length" class="media-grid">
              <div v-for="media in originalImageList" :key="media.id || media.mediaUrl" class="media-item">
                <el-image
                  :src="media.mediaUrl"
                  :preview-src-list="originalImagePreviewList"
                  fit="cover"
                  class="media-thumb"
                ></el-image>
              </div>
            </div>
            <el-empty v-else description="暂无媒体内容"></el-empty>
          </el-card>
        </template>
        <el-empty v-else description="暂无帖子原文"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getReports, getReportDetail, processReport, getPostDetail, offlinePost, deletePost } from '../../api'

export default {
  name: 'ReportManage',
  data() {
    return {
      query: { status: '', targetType: '', pageNum: 1, pageSize: 10 },
      list: [], total: 0, loading: false,
      detailVisible: false, currentReport: null,
      postVisible: false, postLoading: false, currentPost: null
    }
  },
  computed: {
    originalImageList() {
      const list = Array.isArray(this.currentPost && this.currentPost.mediaList) ? this.currentPost.mediaList : []
      return list.filter(item => this.isImageMedia(item))
    },
    originalImagePreviewList() {
      return this.originalImageList.map(item => item.mediaUrl).filter(Boolean)
    },
    postContentText() {
      if (!this.currentPost) return '-'
      return this.currentPost.content || this.currentPost.description || this.currentPost.postContent || this.currentPost.detailContent || '-'
    }
  },
  created() { this.fetchList() },
  methods: {
    fetchList() {
      this.loading = true
      getReports(this.query).then(res => {
        const records = res.data.records || res.data || []
        this.list = records.map(item => ({
          ...item,
          reporterName: item.reporterName || item.reporterNickname || item.reporterUserId || '',
          reportedName: item.reportedName || item.targetName || item.targetId || '',
          reportType: item.reportType || item.reason || '',
          reportTypeLabel: this.formatReportType(item.reportType || item.reason || ''),
          status: item.status || 'PENDING'
        }))
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    search() { this.query.pageNum = 1; this.fetchList() },
    reset() { this.query = { status: '', targetType: '', pageNum: 1, pageSize: 10 }; this.fetchList() },
    handleDetail(row) {
      getReportDetail(row.id).then(res => {
        const data = res.data || {}
        this.currentReport = {
          ...data,
          reporterName: data.reporterName || data.reporterNickname || data.reporterUserId || '',
          reportedName: data.reportedName || data.targetName || data.targetId || '',
          reportType: data.reportType || data.reason || '',
          reportTypeLabel: this.formatReportType(data.reportType || data.reason || ''),
          status: data.status || 'PENDING'
        }
        this.detailVisible = true
      })
    },
    handleProcess(row) {
      this.$prompt('请输入处理结果', '处理举报', { inputType: 'textarea' }).then(({ value }) => {
        processReport(row.id, { status: 'PROCESSED', processResult: value }).then(() => {
          this.$message.success('处理成功')
          this.fetchList()
        })
      }).catch(() => {})
    },
    async handleViewOriginalPost(row) {
      const postId = row.postId || row.targetId
      if (!postId) {
        this.$message.warning('未找到帖子ID')
        return
      }
      this.postLoading = true
      this.currentPost = null
      this.postVisible = true
      try {
        const res = await getPostDetail(postId)
        this.currentPost = res.data || {}
      } catch (e) {
        this.$message.error('加载帖子原文失败')
      } finally {
        this.postLoading = false
      }
    },
    handleOfflinePost(row) {
      const postId = row.postId || row.targetId
      if (!postId) {
        this.$message.warning('未找到帖子ID')
        return
      }
      this.$confirm('确定要下架该违规帖子吗？', '提示', { type: 'warning' }).then(() => {
        offlinePost(postId).then(() => {
          this.$message.success('已下架')
          this.fetchList()
        })
      }).catch(() => {})
    },
    handleDeletePost(row) {
      const postId = row.postId || row.targetId
      if (!postId) {
        this.$message.warning('未找到帖子ID')
        return
      }
      this.$confirm('确定要删除该违规帖子吗？删除后不可恢复。', '提示', { type: 'warning' }).then(() => {
        deletePost(postId).then(() => {
          this.$message.success('已删除')
          this.fetchList()
        })
      }).catch(() => {})
    },
    formatTargetType(type) {
      return type === 'POST' ? '帖子' : type === 'USER' ? '用户' : '聊天'
    },
    formatStatus(status) {
      return status === 'PROCESSED' ? '已处理' : status === 'INVALID' ? '无效' : '待处理'
    },
    formatStatusType(status) {
      return status === 'PROCESSED' ? 'success' : status === 'INVALID' ? 'info' : 'warning'
    },
    formatReportType(type) {
      const map = {
        FALSE_INFO: '虚假信息',
        ILLEGAL: '违法信息',
        FRAUD: '诈骗',
        PORN: '色情低俗',
        COPYRIGHT: '侵权',
        OTHER: '其他'
      }
      return map[type] || type || '其他'
    },
    isPending(status) {
      return status === 0 || status === '0' || status === 'PENDING'
    },
    statusTagType(status) {
      if (status === 1 || status === '1' || status === 'PUBLISHED') return 'success'
      if (status === 2 || status === '2' || status === 'PENDING_APPROVAL' || status === 'WORD_CHECKING' || status === 'AI_CHECKING') return 'warning'
      if (status === 'WORD_REJECTED' || status === 'AI_REJECTED' || status === 'REJECTED') return 'danger'
      return 'info'
    },
    statusText(status) {
      if (status === 1 || status === '1' || status === 'PUBLISHED') return '已发布'
      if (status === 2 || status === '2' || status === 'PENDING_APPROVAL' || status === 'WORD_CHECKING' || status === 'AI_CHECKING') return '待审核'
      if (status === 'OFFLINE' || status === 0 || status === '0') return '已下架'
      if (status === 'WORD_REJECTED' || status === 'AI_REJECTED' || status === 'REJECTED') return '已驳回'
      return status || '-'
    },
    postTypeText(postType) {
      if (postType === 'SUPPLY') return '供给'
      if (postType === 'DEMAND') return '需求'
      return postType || '-'
    },
    isImageMedia(media) {
      const type = String(media && media.mediaType ? media.mediaType : '').toUpperCase()
      if (type.includes('IMAGE') || type.includes('PICTURE') || type.includes('PHOTO')) return true
      const url = String(media && media.mediaUrl ? media.mediaUrl : '').toLowerCase()
      return /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/.test(url)
    }
  }
}
</script>

<style scoped>
.post-content-block {
  white-space: pre-wrap;
  line-height: 1.8;
  color: #303133;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.media-item {
  width: 120px;
}

.media-thumb {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  display: block;
}
</style>
